import React, { useEffect, useState } from "react";
import { FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const MIN_SPOTS = 3;
export function ScarcityBar() {
  const [spotsLeft, setSpotsLeft] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpotsLeft(s => s > MIN_SPOTS ? s - 1 : s);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const claimed = Math.round((TOTAL_SPOTS - spotsLeft) / TOTAL_SPOTS * 100);
  return <div className="rounded-2xl border border-alert/20 bg-alert-light/60 p-4" data-id="element-274" data-mp="2g5tl87yx2ixj">
      <div className="flex items-center justify-between gap-3" data-id="element-275" data-mp="2g3qkou0517ek">
        <p className="flex items-center gap-2 text-[15px] font-bold text-ink" data-id="element-276" data-mp="227ddqet8coec">
          <FlameIcon className="h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-277" data-mp="274dafz46wess" />
          Only <span className="text-alert" data-id="element-278" data-mp="e5pugzjwygu">{spotsLeft} spots</span> left at the launch price
        </p>
        <span className="shrink-0 text-sm font-extrabold text-alert" data-id="element-279" data-mp="5ebm6agrn959">{claimed}%</span>
      </div>
      <div className="mt-3 h-3.5 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={claimed} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-280" data-mp="33md2x11rxsn9">
        <div className="h-full rounded-full bg-alert transition-[width] duration-300 ease-out" style={{
        width: `${claimed}%`
      }} data-id="element-281" data-mp="3dbwkm3dr3ggj" />
      </div>
      <p className="mt-2 text-xs font-medium text-muted" data-id="element-282" data-mp="2knr4jtxn6fn1">When these spots are gone, the price returns to $97.</p>
    </div>;
}